// Module
var code = "<article class=\"message is-warning\"> <div class=\"message-header\"> <p><span class=\"icon\"><i class=\"fa-solid fa-circle-exclamation\"></i></span><span>You are not authorised to this page.</span></p> </div> <div class=\"message-body\"> <p>Try to <a href=\"/app/auth\">:message</a></p> </div> </article> ";
// Exports
export default code;